<template>
  <div class="box">
    <el-button size="small" type="primary" v-print="'#printTest'">
      打印
    </el-button>
    <div id="printTest">
      <div
        class="box_printTest"
        v-for="(item, index) in newPrintList"
        :key="index"
        style="page-break-after: always"
      >
        <div>
          <table>
            <tr class="box_title">
              <td colspan="11">装配电机信息跟踪卡</td>
              <td>序号</td>
              <td>{{ item.sortNo }}</td>
            </tr>
            <tr>
              <td>装配日期</td>
              <td>生产批次号</td>
              <td>规格型号</td>
              <td>数量</td>
              <td>安装方式</td>
              <td>出线方式</td>
              <td>功率 kW</td>
              <td>颜色</td>
              <td>包装</td>
              <td>中心孔</td>
              <td>销售合同号</td>
              <td>技术单号&工号&代码</td>
              <td>客户</td>
            </tr>
            <tr class="box_data">
              <td>{{ item.fitDate }}</td>
              <td>{{ item.orderNo }}</td>
              <td>{{ item.productSpec }}</td>
              <td class="font_bold">{{ item.amount }}</td>
              <td>{{ item.installMethod }}</td>
              <td>{{ item.wiringMethod }}</td>
              <td>{{ item.power }}</td>
              <!-- <td>{{ item.color.length > 20 ? item.color.slice(0, 18) + '...': item.color }}</td> -->
              <td>{{ item.color }}</td>
              <td>{{ item.packageVar }}</td>
              <td>{{ item.centralHole }}</td>
              <td>{{ item.salesContract }}</td>
              <td>{{ item.technicalCode }}</td>
              <td>{{ item.custom }}</td>
            </tr>
            <tr>
              <td class="info font_bold">装配说明</td>
              <td
                class="info info_content"
                colspan="11"
                align="left"
                valign="top"
                style="white-space: pre-wrap"
              >
                {{ item.remark2 }}
              </td>
              <td class="info">
                <div class="code_box">
                  <!-- <PreviewQrCode
                    width="150"
                    height="150"
                    :labelNo="item.num"
                  ></PreviewQrCode> -->
                  <img
                    style="width: 150px"
                    :src="item.qrcode"
                    alt=""
                    srcset=""
                  />
                </div>
                <span>{{ item.productCode }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  components: {
    PreviewQrCode: () => import("../../views/qrCode/previewQrCode.vue"),
  },
  props: {
    printArr: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      newPrintList: [],
    };
  },
  mounted() {
    this.getNewArr();
  },
  methods: {
    getNewArr() {
      let newPrintArr = [];
      this.printArr.forEach((el, i) => {
        let itemArr = el.remark2.split(/\n+/);
        let num = 0;
        let row = 0;
        itemArr.forEach((el) => {
          num++;
          if (num < 22) row++;
          if (el.length >= 65) {
            console.log("el.length", el.length, el.length / 65);
            num = num + Math.trunc(el.length / 65);
          }
        });
        let str1 = null;
        let str2 = null;
        console.log("num", num);
        console.log("row", row);
        if (num > 22) {
          // if (itemArr.length > 16) {
          // str1 = itemArr.slice(0, 16).join("\n");
          // str2 = itemArr.slice(16, itemArr.length).join("\n");
          str1 = itemArr.slice(0, row).join("\n");
          str2 = itemArr.slice(row, itemArr.length).join("\n");

          newPrintArr.push({
            ...el,
            remark2: str1,
          });
          newPrintArr.push({
            ...el,
            remark2: str2,
          });
        } else {
          newPrintArr.push(el);
        }
      });
      console.log("newPrintArr", newPrintArr);
      this.newPrintList = newPrintArr;
    },
  },
};
</script>

<style>
.box {
  background: white;
  height: 800px;
  overflow-y: auto;
}
.box_printTest {
  font-size: 16px;
  font-family: "宋体";
  /* width: 867px; */
  /* width: 210mm;
  height: 297mm; */
  width: 297mm;
  height: 205mm;
  /* margin-left: 10px; */
  /* margin-top: 25px; */
  padding: 30px 10px 10px;
  box-sizing: border-box;
  color: windowtext;
  font-size: 12pt;
  font-weight: 500;
  font-style: normal;
  font-family: "宋体";
  overflow: hidden;
}
.box_printTest .box_title {
  /* font-size: 28px; */
  font-size: 14pt;
  text-align: center;
  font-weight: 800;
  padding-bottom: 20px;
}
.box_printTest .box_data {
  /* height: 100px; */
  height: 70px;
}
.box_printTest .font_bold {
  font-size: 17pt;
  font-weight: 800;
}
.box_printTest table td {
  width: 120px;
  border: 2px solid windowtext;
  padding: 8px 5px;
  text-align: center;
  /* white-space: nowrap; */
  word-break: break-all;
}
.box_printTest table {
  border-collapse: collapse;
  text-align: center;
  /* width: 867px; */
}
.box_printTest table td:nth-child(1) {
  width: 130px;
}
.box_printTest table tr:nth-child(2) td:nth-child(2) {
  width: 180px;
}
.box_printTest table td:nth-child(3) {
  width: 230px;
}
.box_printTest table td:nth-child(4) {
  width: 60px;
}
.box_printTest table td:nth-child(5) {
  width: 80px;
}
.box_printTest table td:nth-child(6),
.box_printTest table td:nth-child(7),
.box_printTest table td:nth-child(9) {
  width: 85px;
}
.box_printTest table td:nth-child(10) {
  width: 100px;
}
.box_printTest table td:nth-child(8) {
  width: 200px;
}
.box_printTest table td:nth-child(11) {
  width: 200px;
}
.box_printTest table td:nth-child(12) {
  width: 180px;
}
.box_printTest table td:last-child {
  width: 156px;
}
.info {
  height: 550px;
}

.info_content {
  text-align: left !important;
}

.code_box {
  width: 150px;
  margin: 0 auto;
}
/* 去掉页眉页脚 */
@page {
  size: auto;
  margin: 0mm;
}
</style>
